export default __webpack_public_path__ + "static/media/StepsActive01.0494ecee.svg";